import { AgResourceLanguage } from '../types';
import { sharePacks as EnUsSharePacks } from '../en-us/sharePacks';

export const sharePacks: AgResourceLanguage['sharePacks'] = {
  ...EnUsSharePacks,
  shippingFields: {
    title: 'Vart skickar vi denna gratisgåva?',
    subtitle:
      'Din vän kommer att få sina AG1-resförpackningar inom 3 - 5 arbetsdagar. Du kan spåra leveransen i din orderhistorik.',
    email: 'Vännens E-post',
    giftMessage: 'Gåvobudskap (max 500 tecken)',
    country: 'Land/region',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    addressLine1: 'Adress',
    addressLine2: 'Lägenhet, Suite, Etc (valfritt)',
    city: 'Stad',
    state: 'Stat',
    zipCode: 'Postnummer',
    phone: 'Telefon',
    submitButtonText: 'Spara',
    cancelButtonText: 'Avbryt',
    label: 'Skicka som gåva',
    caption: `
    <p>Genom att lägga denna beställning godkänner du 
      <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Användarvillkoren</a> 
      och&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Integritetspolicyn</a>.
    </p>
  `
  },
  commonError: 'Något gick fel. Försök igen senare.',
  title: 'Dela GRATIS AG1 Reseförpackningar med dina vänner:',
  subtitle:
    'Ge dem en smak av hur bra det känns att ta hand om sin hälsa, med ett 5-pack — på oss.*',
  disclosure:
    '*Endast för aktiva prenumeranter. Erbjudandet om gratis AG1-resförpackningar gäller i 30 dagar efter att du har blivit informerad. Gratis AG1-resförpackningar är inte överförbara, måste lösas in via medlemsportalen och kan endast skickas till adresser i USA. Max tre 5-pack AG1-resförpackningar per kvalificerad kund.',
  status: {
    shared: 'Du har delat alla dina paket',
    expired:
      'Pilotprogrammet för att dela gratis paket har avslutats, återkom för fler erbjudanden!',
    limited: 'Tidsbegränsat Program',
    expiring: 'Erbjudandet om gratis reseförpackningar löper ut {{date}}.'
  },
  button: {
    share: 'Dela 5 Reseförpackningar',
    expired: 'Utgånget',
    viewOrder: 'Visa Beställning',
    shared: 'Delat'
  },
  modal: {
    head: 'Dela Gratis Reseförpackningar',
    title: 'Vart skickar vi denna gratisgåva?',
    subtitle:
      'Din vän kommer att få sina AG1-resförpackningar inom 3 - 5 arbetsdagar. Du kan spåra leveransen i din orderhistorik.'
  },
  checkout: {
    success: 'Din beställning har skapats framgångsrikt.'
  },
  subscriptionFreeGiftName: 'Dela Gratis Paket',
  buttonTrack: 'Spåra Beställning',
  freeGiftPrice: 'Gratis',
  subscriptionNameLabel: 'Beställningstyp'
};
